// @flow
/* eslint-disable import/prefer-default-export */
import type { Saga } from 'redux-saga';

import { spawn, put, take } from 'redux-saga/effects';

import * as a from './actions';
import * as c from './constants';

type DialogOptions = {
  title?: string,
  message: string,
  isHtml?: boolean,
};

type ErrorAction = {
  type: string,
  payload: {
    message: string,
  },
};

export function* showConfirmDialogSaga(payload: DialogOptions): Saga<boolean> {
  const action = a.confirmDialog(payload);
  yield put(action);
  const resolveAction = yield take(
    (i) => i.type === c.RESOLVE_DIALOG && i.payload.id === action.payload.id,
  );

  return !!resolveAction.payload.value;
}

export function* showErrorDialogSaga(payload: DialogOptions): Saga<void> {
  const action = a.errorDialog(payload);
  yield put(action);
  yield take((i) => i.type === c.RESOLVE_DIALOG && i.payload.id === action.payload.id);
}

export function* showErrorDialogOnErrorActionSaga(action: ErrorAction): Saga<void> {
  yield spawn(showErrorDialogSaga, { message: action.payload.message });
}



// WEBPACK FOOTER //
// ./src/common/components/dialog/sagas.js